import { defineComponent as _defineComponent } from 'vue'
import type { PropType } from 'vue'
  import type { OnboardingSurveyAnswerResponseData } from '@/services/interfaces/Auth0'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingSurveyAnswerResponseView',
  props: {
    answerResponseData: {
      type: Object as PropType<OnboardingSurveyAnswerResponseData>,
      required: true,
    },
  },
  setup(__props) {

  

return { __sfc: true, }
}

})